<template>
	<div class="free-source">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item v-for="(item, i) in breadcrumbs" :to="{ path: item.path }" :key="i">
				{{item.meta.breadcrumb}}
			</el-breadcrumb-item>
		</el-breadcrumb>
		<Tabs class="tabs"></Tabs>
	</div>
</template>

<script>
import Tabs from "@/components/challenge/freeResource/Tabs.vue";

export default {
	data() {
		return {};
	},
	computed: {
		breadcrumbs() {
			return this.$route.matched.filter(route => route.meta.breadcrumb);
		}
	},
	methods: {},
	created() { },
	mounted() { },
	components: {
		Tabs
	}
};
</script>

<style lang="scss" scoped>
.tabs {
	margin-top: 22px;
	margin-bottom: 80px;
}
</style>